import { Card } from '@sandstein/bitv-card';
export default [
  {
    selector: '.js-card',
    cls: Card
  }
];
